import { DEALER_DETAILS,
    BOOKING_DETAILS,
    CURRENT_STEP,
    CAR_INFOS,
    CAR_KILO,
    CODE_PAS_FOR_ANNUALSERVICE,
    SERVICES,
    SERVICES_SELECTED,
    COMMENT_SERVICES,
    PERSONEL_INFOS,
    PREMIUM_SERVICES_DSVALET,
    SELECTED_PREMIUM_SERVICES,
    LIST_PREMIUM_SERVICES,
    EDITMODE,
    DIALOG_CONFIRMATION_CHANGE_STEP,
    ATTACHMENTID,
    //ATTACHMENTURL,
    FILES,
    DATELIMIT,
	SELECTED_LAT,
	SELECTED_LONG,
    FILTER_DEALERS_BY,
    FILTER_BY_CHOICE,
	DEALERS_FILTRED,
    IDRDVLEADS } from './types';

export const dealerSetAction = dealer => ({
    type: DEALER_DETAILS,
    dealer,
});
export const bookingSetAction = booking => ({
    type: BOOKING_DETAILS,
    booking,
});
export const CurrentStepSetAction = step => ({
    type: CURRENT_STEP,
    step,
});

export const setCodePasForAnnualService = codePasForAnnualService => ({
    type: CODE_PAS_FOR_ANNUALSERVICE,
    codePasForAnnualService,
});

export const setVeiculeInfos = car => ({
    type: CAR_INFOS,
    car,
});
export const setVeiculeKilo = kilo => ({
    type: CAR_KILO,
    kilo,
});
export const setServices = service => ({
    type: SERVICES,
    service,
});
export const setEditMode = isEditMode => ({
    type: EDITMODE,
    isEditMode,
});
export const selectedServices = (SelectedServices) => ({    
    type: SERVICES_SELECTED,
    SelectedServices,
});
export const setCommentServices = (commentServices) => ({    
    type: COMMENT_SERVICES,
    commentServices,
});
export const setPersonalInformations = (personalInfos) => ({
    type: PERSONEL_INFOS,
    personalInfos,
});
export const setSelectedPremiumServicesToStore = (selectedPremiumServices) => ({
    type: SELECTED_PREMIUM_SERVICES,
    selectedPremiumServices,
});
export const setListPremiumServicesToStore = (listPremiumServices) => ({
    type: LIST_PREMIUM_SERVICES,
    listPremiumServices,
});
export const setSelectedPremiumServicesDsValetToStore = (selectedDsValetPremiumServices) => ({
    type: PREMIUM_SERVICES_DSVALET,
    selectedDsValetPremiumServices,
});
export const setDialogConfirmationStepChange = (visibaleDialogId) => ({
    type: DIALOG_CONFIRMATION_CHANGE_STEP,
    visibaleDialogId,
});
export const setUploadFiles = (UploadFiles) => ({
    type: FILES,
    UploadFiles,
});
export const setCustomerAttachmentId = (customerAttachmentId) => ({
    type: ATTACHMENTID,
    customerAttachmentId,
});
// export const setCustomerAttachmentUrl = (customerAttachmentUrl) => ({
//     type: ATTACHMENTURL,
//     customerAttachmentUrl,
// });
export const setDateLimitModif = (dateLimitModif) => ({
    type: DATELIMIT,
    dateLimitModif,
});
export const setSelectedLat = (selectedLat) => ({
    type: SELECTED_LAT,
    selectedLat,
});
export const setSelectedLong = (selectedLong) => ({
    type: SELECTED_LONG,
    selectedLong,
});
export const setFilterDealersBy = (filterDealersBy) => ({
    type: FILTER_DEALERS_BY,
    filterDealersBy,
});
export const setFilterByChoice = (filterByChoice) => ({
    type: FILTER_BY_CHOICE,
    filterByChoice,
});
export const setListDealersFiltred = (dealersFiltred) => ({
    type: DEALERS_FILTRED,
    dealersFiltred,
});
export const setIdRdvLeads = (idRdvLeads) => ({
    type: IDRDVLEADS,
    idRdvLeads,
});